import { useUploadMeterModelFiles } from '@/api/hooks/meter-models/useUploadMeterModelFiles';
import { DRIVE_FOLDER_TYPE_TRANSLATED, EMPTY_FOLDER_MESSAGES } from '@/components/enmon/files/constants';
import { ModelFilesGallery } from '@/components/enmon/files/model_files_gallery';
import { Icon } from '@/components/icon';
import type { DriveFolderType, SerializedMeterModel } from '@enmon/commons/lib/tools';
import { Tooltip, Upload } from 'antd';
import type { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import { Button, Card } from 'components';
import type { FC } from 'react';
import { useIsResellerRole } from '@/hooks/useUser';

interface MeterModelFilesCardProps {
  model?: SerializedMeterModel;
  folderType: DriveFolderType;
  accept: string;
}

export const MeterModelFilesCard: FC<MeterModelFilesCardProps> = ({ model, folderType, accept }) => {
  const { mutate: uploadFiles, isLoading: isUploading } = useUploadMeterModelFiles();
  const isReseller = useIsResellerRole();

  const handleUploadChange = (info: UploadChangeParam<UploadFile>) => {
    const newFiles = info.fileList
      .filter(file => file.originFileObj && file.status !== 'error')
      .map(file => file.originFileObj as File);

    if (newFiles.length > 0) uploadFiles({ modelId: model?.id, folderType, files: newFiles });
  };

  return (
    <Card
      title={DRIVE_FOLDER_TYPE_TRANSLATED[folderType]}
      extra={
        isReseller ? null : (
          <Upload
            fileList={[]}
            onChange={handleUploadChange}
            beforeUpload={() => false}
            multiple
            showUploadList={false}
            disabled={isUploading}
            accept={accept}
          >
            <Tooltip title={!model?.folder_drive_id ? 'Folder not available' : null}>
              <Button
                loading={isUploading}
                disabled={!model?.folder_drive_id}
                icon={isUploading ? <Icon iconString="spinner" /> : <Icon iconString="plus" />}
                type="text"
              >
                {isUploading ? 'Uploading...' : 'Upload'}
              </Button>
            </Tooltip>
          </Upload>
        )
      }
    >
      <ModelFilesGallery
        enablePreview
        model={model}
        folderType={folderType}
        emptyMessage={EMPTY_FOLDER_MESSAGES[folderType]}
        source="model"
      />
    </Card>
  );
};
